export const LOCAL_STORAGE_RESTAURANT_ID_KEY = 'restaurantId';
export const LOCAL_STORAGE_RESTAURANT_DATA_PREFIX = 'restaurant_data_';
